import React from "react";
import "./style.css";
import {QuestionnaireMultiple} from "../../../../components/QuestionnaireMultiple";
import {HEALTH_CONCERNS} from "../../../../const/WeightLossQuestionnaire";

export const HealthConcerns = (props) => {
  const list = {
    title: "Any health concerns?",
    list: [{value: "None", isNone: true},
      ...HEALTH_CONCERNS]
  };

  return (
    <div className="gallery-page">
      <QuestionnaireMultiple {...props} list={list} />
    </div>
  );
};
